const passwordRecovery = {
  password: {
    presence: {
      allowEmpty: false,
      message: "Senha para acessar a PDVend é obrigatória."
    },
    length: {
      minimum: 8,
      message: "Senha deve ter no mínimo 8 caracteres."
    }
  },
  confirmPassword: {
    presence: {
      allowEmpty: false,
      message: "Confirmação da Senha é obrigatória."
    },
    equality: {
      attribute: "password",
      message: "Senha e Confirmação da Senha devem ser iguais."
    }
  }
};

export default {
  passwordRecovery
};



// WEBPACK FOOTER //
// ./src/core/constraint/password-recovery.constraint.js